import React from "react";
import { Group, Text, ThemeIcon, Box } from "@mantine/core";

interface JoyrideContentProps {
  icon?: React.ReactNode;
  title: string;
  highlights?: string[];
  description: string;
  tip?: string;
}

const JoyrideContent: React.FC<JoyrideContentProps> = ({
  icon,
  title,
  description,
  tip,
}) => (
  <Box maw={340} style={{ textAlign: "left", padding: 0 }}>
    <Group gap="xs" mb="sm">
      {icon && (
        <ThemeIcon
          size={40}
          radius="xl"
          color="yellow"
          variant="light"
          style={{ flexShrink: 0 }}
        >
          {icon}
        </ThemeIcon>
      )}
      <Text fw={700} size="lg" c="dark">
        {title}
      </Text>
    </Group>
    <Text size="sm" c="dimmed">
      {description}
    </Text>
    {tip && (
      <Text size="xs" c="gray.6" mt="xs" style={{ fontStyle: "italic" }}>
        {tip}
      </Text>
    )}
  </Box>
);

export default JoyrideContent;
